import { urls } from "../constants/constants";
import Axios from "../helper/axios";

const axios = new Axios();

class EmailEditorService {
  getEmailEditor(practiceId) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/emailTemplate`,
    };

    return axios.get(option);
  }

  getBeeFreeToken() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/beeFreeToken`,
    };
    return axios.get(option);
  }
  getEmailEditorById(id) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/emailTemplate?emailTemplateId=${id}`,
    };
    return axios.get(option);
  }
  addEmailTemplate(params) {
    const options = {
      url: `${urls.aspariaBackend}api/v1/broadcast/emailTemplate`,
      data: params,
    };
    return axios.post(options);
  }
  updateEmailTemplate(params) {
    const options = {
      url: `${urls.aspariaBackend}api/v1/broadcast/emailTemplate`,
      data: params,
    };
    return axios.put(options);
  }

  checkEmailTemplateExists(name, accounts = []) {
    const options = {
      url: `${urls.aspariaBackend}api/v1/email-templates/exists`,
      data: {
        name,
        accounts,
      },
    };
    return axios.post(options);
  }
}
const emailEditorService = new EmailEditorService();
export default emailEditorService;
